export const CompanyProfileConstants = {
   GET_COMPANY_DETAILS_REQUEST  : "GET_COMPANY_DETAILS_REQUEST",
   GET_COMPANY_DETAILS_SUCCESS : "GET_COMPANY_DETAILS_SUCCESS",
   GET_COMPANY_DETAILS_FAILURE : "GET_COMPANY_DETAILS_FAILURE",

   GET_COMPANIES_REQUEST : "GET_COMPANIES_REQUEST",
   GET_COMPANIES_SUCCESS : "GET_COMPANIES_SUCCESS",
   GET_COMPANIES_FAILURE : "GET_COMPANIES_FAILURE",
   //FOLLOW_COMPANY_REQUEST : "FOLLOW_COMPANY_REQUEST",
   FOLLOW_COMPANY_SUCCESS : "FOLLOW_COMPANY_SUCCESS",
   FOLLOW_COMPANY_FAILURE : "FOLLOW_COMPANY_FAILURE",
   //UNFOLLOW_COMPANY_REQUEST : "UNFOLLOW_COMPANY_REQUEST",
   UNFOLLOW_COMPANY_SUCCESS : "UNFOLLOW_COMPANY_SUCCESS",
   UNFOLLOW_COMPANY_FAILURE : "UNFOLLOW_COMPANY_FAILURE",
}

export const UserDetailsConstants = {
   GET_USER_DETAILS_REQUEST  : "GET_USER_DETAILS_REQUEST",
   GET_USER_DETAILS_SUCCESS  : "GET_USER_DETAILS_SUCCESS",
   GET_USER_DETAILS_FAILURE  : "GET_USER_DETAILS_FAILURE",
}